import { render, staticRenderFns } from "./PageButton.vue?vue&type=template&id=1481be64&scoped=true&"
import script from "./PageButton.vue?vue&type=script&lang=ts&"
export * from "./PageButton.vue?vue&type=script&lang=ts&"
import style0 from "./PageButton.vue?vue&type=style&index=0&id=1481be64&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1481be64",
  null
  
)

export default component.exports